
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Analytic": [
      "AnalyticGoogleMap",
      "AnalyticSession",
      "AnalyticWidget"
    ],
    "AnalyticWidgetUnion": [
      "Event",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "AutocompleteNoPlaces": [
      "Event",
      "Hashtag",
      "Sharry",
      "User",
      "Wonder"
    ],
    "AutocompleteSearchResult": [
      "Event",
      "Hashtag",
      "Place",
      "Sharry",
      "User",
      "Wonder"
    ],
    "ChatUnion": [
      "Conversation",
      "User"
    ],
    "CommunityPost": [
      "NotificationFeed",
      "Post"
    ],
    "ContentEntity": [
      "Event",
      "LikeCollection",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "ContentOwner": [
      "User"
    ],
    "ContentUnion": [
      "Event",
      "Land",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "GalleryContent": [
      "GalleryEmbed",
      "GalleryImage"
    ],
    "LikeCollectionContentUnion": [
      "Event",
      "FeaturedCard",
      "Land",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "NotificationReference": [
      "BecomePro",
      "CartItem",
      "Conversation",
      "CustomNotification",
      "Event",
      "LikeCollection",
      "LoginBlank",
      "Post",
      "Sharry",
      "SharryReview",
      "User",
      "UserCherryGoal",
      "Wonder"
    ],
    "PaymentResource": [
      "ShopOrder",
      "User"
    ],
    "PrerenderUnion": [
      "Category",
      "CustomPage",
      "Event",
      "Land",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "ReportableEntity": [
      "Event",
      "Place",
      "Post",
      "Sharry",
      "SharryReview",
      "User",
      "Wonder"
    ],
    "SearchableUnion": [
      "Event",
      "FeaturedCard",
      "Sharry",
      "User",
      "Wonder"
    ],
    "SharryContent": [
      "Event",
      "Post",
      "PostTranslated",
      "Sharry",
      "Wonder"
    ],
    "UserCherryGoalResource": [
      "CherryDiscount",
      "GiftCard"
    ],
    "UserSearchResult": [
      "User"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Analytic": [
      "AnalyticGoogleMap",
      "AnalyticSession",
      "AnalyticWidget"
    ],
    "AnalyticWidgetUnion": [
      "Event",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "AutocompleteNoPlaces": [
      "Event",
      "Hashtag",
      "Sharry",
      "User",
      "Wonder"
    ],
    "AutocompleteSearchResult": [
      "Event",
      "Hashtag",
      "Place",
      "Sharry",
      "User",
      "Wonder"
    ],
    "ChatUnion": [
      "Conversation",
      "User"
    ],
    "CommunityPost": [
      "NotificationFeed",
      "Post"
    ],
    "ContentEntity": [
      "Event",
      "LikeCollection",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "ContentOwner": [
      "User"
    ],
    "ContentUnion": [
      "Event",
      "Land",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "GalleryContent": [
      "GalleryEmbed",
      "GalleryImage"
    ],
    "LikeCollectionContentUnion": [
      "Event",
      "FeaturedCard",
      "Land",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "NotificationReference": [
      "BecomePro",
      "CartItem",
      "Conversation",
      "CustomNotification",
      "Event",
      "LikeCollection",
      "LoginBlank",
      "Post",
      "Sharry",
      "SharryReview",
      "User",
      "UserCherryGoal",
      "Wonder"
    ],
    "PaymentResource": [
      "ShopOrder",
      "User"
    ],
    "PrerenderUnion": [
      "Category",
      "CustomPage",
      "Event",
      "Land",
      "Post",
      "Sharry",
      "User",
      "Wonder"
    ],
    "ReportableEntity": [
      "Event",
      "Place",
      "Post",
      "Sharry",
      "SharryReview",
      "User",
      "Wonder"
    ],
    "SearchableUnion": [
      "Event",
      "FeaturedCard",
      "Sharry",
      "User",
      "Wonder"
    ],
    "SharryContent": [
      "Event",
      "Post",
      "PostTranslated",
      "Sharry",
      "Wonder"
    ],
    "UserCherryGoalResource": [
      "CherryDiscount",
      "GiftCard"
    ],
    "UserSearchResult": [
      "User"
    ]
  }
};
      export default result;
    